import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  callerHistoryInForm: [],
  errorStatus: null,
  mainList: [],
  dispatchBottomList: [],
  admissionMissions: [],
  doctorMissions: [],
  dispatchMission: null,
  fenceTime: null,
  missionAssignInfo: null,
  doctorMission: null,
  followUpDashboard: [],
  followUpMissions: [],
  followUpMission: null,
  followUpMissionData: null,
  otherOrganization: [],
  admissionHistory: [],
  missionReportDetail: null,
  missionReportUsers: null,
  missionPhoneLocation: [],
  missionPhoneLocationWithState: [],
  allMissionStartTriages: [],
};
const getters = {
  getApiLoad_53: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_MissionStartTriage(state, allMissionStartTriages) {
    state.allMissionStartTriages = allMissionStartTriages;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_AllCallerHistory(state, data) {
    state.callerHistoryInForm = data;
  },
  SET_MainList(state, missions) {
    state.mainList = missions;
  },
  SET_DispatchBotoomList(state, missions) {
    state.dispatchBottomList = missions;
  },
  SET_MissionPhoneByDispatch(state, mission) {
    state.dispatchMission = mission;
  },
  SET_MissionPhoneFenceTimes(state, data) {
    state.fenceTime = data;
  },
  SET_AdmissionMissions(state, data) {
    state.admissionMissions = data;
  },
  SET_AdmissionAssignHospital(state, data) {
    state.missionAssignInfo = data;
  },
  SET_DoctorMissions(state, data) {
    state.doctorMissions = data;
  },
  SET_DoctorMission(state, data) {
    state.doctorMission = data;
  },
  SET_FollowUpDashboard(state, data) {
    state.followUpDashboard = data;
  },
  SET_FollowUpMissions(state, data) {
    state.followUpMissions = data;
  },
  SET_FollowUpMission(state, data) {
    state.followUpMission = data;
  },
  SET_FollowUpMissionData(state, data) {
    state.followUpMissionData = data;
  },
  SET_OtherOrganInfo(state, data) {
    state.otherOrganization = data;
  },
  SET_AdmissionHistory(state, data) {
    state.admissionHistory = data;
  },
  SET_MissionReportDetail(state, data) {
    state.missionReportDetail = data;
  },
  SET_MissionReportUsers(state, data) {
    state.missionReportUsers = data;
  },
  SET_MissionPhoneLocation(state, data) {
    state.missionPhoneLocation = data;
  },
  SET_MissionPhoneLocationWithState(state, data) {
    state.missionPhoneLocationWithState = data;
  },
};
const actions = {
  errorMissionPhone({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllCallerHistoryForMission({ commit, dispatch, rootState }, callerId) {
    return apiClient
      .get('/MissionPhones/CallerIdHistory?callerId=' + callerId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllCallerHistory', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMainListOfCurrentMision({ commit, dispatch, rootState }) {
    return apiClient
      .get('/MissionPhones/MainList115', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_MainList', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getDispatchBotoomList({ commit, dispatch, rootState }) {
    return apiClient
      .get('/MissionPhones/DispatchBottomList', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DispatchBotoomList', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  addMissionPhone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/MissionPhones', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  sendToOtherCode({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/MissionPhones/OtherCode', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionBy800User({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .get('/MissionPhones/ByDispatch?missionPhoneId=' + missionPhoneId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_MissionPhoneByDispatch', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  modifyMissionBy800User({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/MissionPhones/ModifyByDispatch', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionFenceTimesBy800User({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .get('/MissionPhones/FenceTimes?missionPhoneId=' + missionPhoneId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_MissionPhoneFenceTimes', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  setMoveFromStationTime({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .post(
        '/MissionPhones/MoveFromStation?missionPhoneId=' + missionPhoneId,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  setArriveToLocationTime({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .post(
        '/MissionPhones/ArriveToLocation?missionPhoneId=' + missionPhoneId,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  setMoveFromLocationTime({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .post(
        '/MissionPhones/MoveFromLocation?missionPhoneId=' + missionPhoneId,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  setArriveToHospitalTime({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .post(
        '/MissionPhones/ArriveToHospital?missionPhoneId=' + missionPhoneId,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  setFinishTime({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .post(
        '/MissionPhones/Finish?missionPhoneId=' + missionPhoneId,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  setPatientDeliveryTime({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .post(
        '/MissionPhones/PatientDelivery?missionPhoneId=' + missionPhoneId,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  setArriveToStationTime({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .post(
        '/MissionPhones/ArriveToStation?missionPhoneId=' + missionPhoneId,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getCurrentMissionsForAdmission({ commit, dispatch, rootState }) {
    return apiClient
      .get('/MissionPhones/Admission', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AdmissionMissions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionForAssignHospital({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/MissionPhones/ByAdmission?missionPhoneId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AdmissionAssignHospital', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  sendMissionToHospital({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/MissionPhones/AssignHospital', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  removeHospitalByAdmission({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/MissionPhones/CancelHospital', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getCurrentMissionsForDoctor({ commit, dispatch, rootState }) {
    return apiClient
      .get('/MissionPhones/Doctor', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DoctorMissions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getDoctorSelectedCodeFromMissionPhone({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .get('/MissionPhones/DoctorSelectedCode?missionPhoneId=' + missionPhoneId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DoctorMission', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionPhoneFollowUpDashboard({ commit, dispatch, rootState }) {
    return apiClient
      .get('/MissionPhones/FollowUpDashboard', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_FollowUpDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionsByFollowUp({ commit, dispatch, rootState }) {
    return apiClient
      .get('/MissionPhones/FollowUp', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_FollowUpMissions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionByFollowUp({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/MissionPhones/FollowUpDashboardCode?missionPhoneId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_FollowUpMission', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionDataByFollowUp({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/MissionPhones/DataForFollowUp?missionPhoneId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_FollowUpMissionData', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  setDataByFollowUp({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/MissionPhones/DataByFollowUp', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  finishMissionByFollowUp({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/MissionPhones/FinishWithPatient', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  finishMissionWithOutPatientByFollowUp({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/MissionPhones/FinishWithoutPatient', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionPhoneOtherOrganization({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/MissionPhones/OtherOrganization?missionId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_OtherOrganInfo', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionPhoneAdmissionHistory({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/MissionPhones/AdmissionHistory?missionPhoneId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AdmissionHistory', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionPhoneReportDetail({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/MissionPhones/ReportDetails?missionPhoneId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_MissionReportDetail', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionPhoneReportUsers({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    let url = '/MissionPhones/Users?missionPhoneId=' + missionPhoneId;
    if (patientId) {
      url += '&patientId=' + patientId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_MissionReportUsers', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionPhoneLocations({ commit, dispatch, rootState }, missionPhoneId) {
    let url = '/MissionPhones/Locations?missionPhoneId=' + missionPhoneId;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_MissionPhoneLocation', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getMissionPhoneLocationsWithState({ commit, dispatch, rootState }, missionPhoneId) {
    let url = '/MissionPhones/LocationsWithState?missionPhoneId=' + missionPhoneId;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_MissionPhoneLocationWithState', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  missionPhoneTemp1024({ commit, dispatch, rootState }, missionPhoneId) {
    let url = '/MissionPhones/Temp1024?missionPhoneId=' + missionPhoneId;
    return apiClient
      .post(url, {}, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  missionResendLastState({ commit, dispatch, rootState }, missionPhoneId) {
    let url = '/MissionPhones/ResendLastState?missionPhoneId=' + missionPhoneId;
    return apiClient
      .post(url, {}, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
  getStartTriagesListDispatch: function ({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/MissionPhones/StartTriage', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params,
      })
      .then((response) => {
        commit('SET_MissionStartTriage', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMissionPhone', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
